import { openItemFlowsModal } from "components/ItemFlowsModal";
import {
    type ItemFlowDirectionEnum,
    ItemFlowDirection,
    type NewItemResultDTO,
} from "data/types";

/**
 * opens the itemFlows input dialog for the given itemUri
 *
 * @param {{ itemUri: string }} { itemUri } target folder itemUri
 * @param {{ direction: ItemFlowDirection }} { direction } "in" or "out" (defaults to "in")
 * @param {{ flowId?: string}} { flowId } optional pre-selected flow.id
 * @param {{ visibleFlowIds?: Array<string>}} { visibleFlowIds } optional limit which flowIds are at all visible
 * @param {{ categoryId?: string}} { categoryId } optional pre-selected category.id
 * @param {{ defaultValues?: Object }} { defaultValues } optional default attribute values to pass to form
 * @param {{ previewNewItem?: boolean}} { previewNewItem } internal: whether to preview to the newly created item (defaults to false)
 * @param {{ onDone?: (data: NewItemResultDTO) => void}} { onDone } internal: callback once complete ({success:boolean, itemUri, name, formatId, elementType, ... })
 *
 */

type Context = {
    itemUri: string,
    direction?: ItemFlowDirectionEnum,
    flowId?: string,
    visibleFlowIds?: Array<string>,
    categoryId?: string,
    defaultValues?: Object,
    previewNewItem?: boolean,
    onDone?: (data: NewItemResultDTO) => void,
};

class itemFlows {
    execute = async ({
        itemUri,
        direction = ItemFlowDirection.in,
        flowId,
        visibleFlowIds,
        categoryId,
        defaultValues,
        previewNewItem = true,
        onDone,
    }: Context): Promise<boolean> => {
        await openItemFlowsModal({
            itemUri,
            direction,
            flowId,
            visibleFlowIds,
            categoryId,
            defaultValues,
            previewNewItem,
            onDone,
        });
        return true;
    };
}

export default itemFlows;
